import React from 'react'
import ContentBlock, { ExpandableBlocks } from 'components/ContentBlock'

import Bexio from './Bexio'
import Apaleo from './Apaleo'
import Frutico from './Frutico'
import MeinElster from './MeinElster'
import TimeTracking from './TimeTracking'
import Dsfin from './Dsfin'
import TSELogs from './TSELogs'
import Datev from './Datev'
import Abacus from './Abacus'
import Csb from './Csb'

const Export = props => (
	<ExpandableBlocks>
		{props.appData.countryId !== '1' && // not for Switzerland
			<Datev />
		}
		{props.appData.countryId !== '2' && // not for Germany
			<Abacus />
		}
		{props.appData.countryId !== '1' && // not for Switzerland
			<Csb />
		}
		{props.appData.countryId !== '1' && // not for Switzerland
			<Dsfin />
		}
		{props.appData.countryId !== '1' && // not for Switzerland
			<TSELogs />
		}
		{props.appData.countryId !== '2' && // not for Germany
			<Bexio
				formData={props.formData}
				onUpdate={props.onUpdate}
			/>
		}
		{props.appData.countryId !== '2' && // not for Germany
			<ContentBlock label='Apaleo'>
				<Apaleo />
			</ContentBlock>
		}
		{props.appData.countryId !== '2' && // not for Germany
			<Frutico appData={props.appData} />
		}
		{props.appData.countryId === '2' && // only for Germany
			<MeinElster />
		}
		<TimeTracking {...props} />
	</ExpandableBlocks>
)

export default Export
